import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import { getAvailableChannelList } from "@/api/channel";
export default {
  name: "channelOptions",
  props: {
    value: [Array, String, Number],
    type: Number,
    multiple: Boolean
  },
  data: function data() {
    return {
      label: this.value,
      channelList: []
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAvailableChannelList();
          case 2:
            _this.channelList = _context.sent;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    someSelect: function someSelect() {
      this.$emit("input", this.label);
    },
    getOptionLabel: function getOptionLabel(item) {
      return "".concat(item.label, "\uFF08").concat(item.id, "\uFF09");
    }
  }
};